/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UboDeclarationBeneficiaryAddress
 */
export interface UboDeclarationBeneficiaryAddress {
    /**
     * 
     * @type {string}
     * @memberof UboDeclarationBeneficiaryAddress
     */
    street: string;
    /**
     * 
     * @type {string}
     * @memberof UboDeclarationBeneficiaryAddress
     */
    street2?: string;
    /**
     * 
     * @type {string}
     * @memberof UboDeclarationBeneficiaryAddress
     */
    zipCode: string;
    /**
     * 
     * @type {string}
     * @memberof UboDeclarationBeneficiaryAddress
     */
    city: string;
    /**
     * 
     * @type {string}
     * @memberof UboDeclarationBeneficiaryAddress
     */
    region?: string;
    /**
     * 
     * @type {string}
     * @memberof UboDeclarationBeneficiaryAddress
     */
    country: string;
}

/**
 * Check if a given object implements the UboDeclarationBeneficiaryAddress interface.
 */
export function instanceOfUboDeclarationBeneficiaryAddress(value: object): value is UboDeclarationBeneficiaryAddress {
    if (!('street' in value) || value['street'] === undefined) return false;
    if (!('zipCode' in value) || value['zipCode'] === undefined) return false;
    if (!('city' in value) || value['city'] === undefined) return false;
    if (!('country' in value) || value['country'] === undefined) return false;
    return true;
}

export function UboDeclarationBeneficiaryAddressFromJSON(json: any): UboDeclarationBeneficiaryAddress {
    return UboDeclarationBeneficiaryAddressFromJSONTyped(json, false);
}

export function UboDeclarationBeneficiaryAddressFromJSONTyped(json: any, ignoreDiscriminator: boolean): UboDeclarationBeneficiaryAddress {
    if (json == null) {
        return json;
    }
    return {
        
        'street': json['street'],
        'street2': json['street2'] == null ? undefined : json['street2'],
        'zipCode': json['zipCode'],
        'city': json['city'],
        'region': json['region'] == null ? undefined : json['region'],
        'country': json['country'],
    };
}

export function UboDeclarationBeneficiaryAddressToJSON(value?: UboDeclarationBeneficiaryAddress | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'street': value['street'],
        'street2': value['street2'],
        'zipCode': value['zipCode'],
        'city': value['city'],
        'region': value['region'],
        'country': value['country'],
    };
}

